import cash from "cash-dom";
import dayjs from "dayjs";
import Litepicker from "litepicker";

(function () {
    "use strict";
    const username_ele = cash('#username');
    const firstname_ele = cash('#first_name');
    const lastname_ele = cash('#last_name');
    let changed = false;

    if (username_ele.length && firstname_ele.length && lastname_ele.length) {

        username_ele.each((index, elem) => {
            if (elem.value.length > 0) {
                changed = true;
            }
        })

        firstname_ele.each((index, ele) => {
            ele.addEventListener('input', () => {
                fill_username();
            })
        })

        lastname_ele.each((index, ele) => {
            ele.addEventListener('input', () => {
                fill_username();
            })
        })

        username_ele.each((index, ele) => {
            ele.addEventListener('input', () => {
                changed = true;
            })
        })

        function fill_username() {
            if (changed) return;

            username_ele[0].value = `${lastname_ele.val()}_${firstname_ele.val()}`;
        }
    }

    // Litepicker
    $(".datepicker_employee_salary_add").each(function () {
        let options = {
            lang: 'de-DE',
            autoApply: true,
            singleMode: true,
            numberOfColumns: 1,
            showWeekNumbers: true,
            format: "DD.MM.YYYY",
            dropdowns: {
                minYear: new Date().getFullYear(),
                maxYear: new Date().getFullYear() + 3,
                months: true,
                years: true,
            },
        };

        if (!$(this).val()) {
            let date = dayjs().format(options.format);
            date += !options.singleMode
                ? " - " + dayjs().add(1, "week").format(options.format)
                : "";
            $(this).val(date);
        }

        let picker = new Litepicker({
            element: this,
            ...options,
        });

        fetchJSON(`/api/employee/${this.dataset.employee_id}/salarydates`)
            .then(function (data) {
                picker.setLockDays(data);
            })
    });

    // Litepicker
    $(".datepicker_employee_salary_end").each(function () {
        let options = {
            lang: 'de-DE',
            autoApply: true,
            singleMode: true,
            numberOfColumns: 1,
            showWeekNumbers: true,
            startDate: null,
            minDate: this.dataset.min_date,
            format: "DD.MM.YYYY",
            dropdowns: {
                minYear: new Date().getFullYear(),
                maxYear: new Date().getFullYear() + 3,
                months: true,
                years: true,
            },
        };

        if (!$(this).val()) {
            let date = dayjs().format(options.format);
            date += !options.singleMode
                ? " - " + dayjs().add(1, "week").format(options.format)
                : "";
            $(this).val(date);
        }

        new Litepicker({
            element: this,
            ...options,
        });

    });

    function fetchJSON(url) {
        return fetch(url)
            .then(function (response) {
                return response.json();
            });
    }

})();
